import ErrorStackParser from 'error-stack-parser'
import ipcApiRoute from '@/constants/ipcApiRoute'

const _support = {
  errorMap: new Map(),
  isEE: false,
  ipc: null,
}

function getErrorUid(str) {
  return window.btoa(encodeURIComponent(str))
}

function getTimestamp() {
  return new Date().getTime()
}

function getCurrentRoute() {
  return window.location.pathname
}

function isExistHash(hash) {
  const isExist = _support.errorMap.has(hash)
  if (!isExist) {
    _support.errorMap.set(hash, true)
  }
  return isExist
}

function init(options) {
  const { Renderer } = options
  _support.isEE = Renderer?.isEE || false
  _support.ipc = Renderer?.ipc || null
  listenerError()
}

function listenerError() {
  _support.isEE && window.addEventListener('error', handleError, true)
}

/**
 * 处理错误
 * @param {*} ev
 * @returns
 */
function handleError(ev) {
  const { target } = ev
  if (!target || (target && !target.localName)) {
    const stackFrame = !target
      ? ErrorStackParser.parse(ev)[0]
      : {
          fileName: ev.filename,
          columnNumber: ev.colno,
          lineNumber: ev.lineno,
        }
    const { fileName, columnNumber, lineNumber } = stackFrame
    const errInfo = {
      type: 'error',
      name: ev?.error?.name,
      message: ev.message,
      time: getTimestamp(),
      pathname: getCurrentRoute(),
      fileName,
      line: lineNumber,
      column: columnNumber,
    }
    const hash = getErrorUid(`error-${ev.message}-${fileName}-${columnNumber}`)
    if (!isExistHash(hash)) {
      return reportData(errInfo)
    }
  }

  // 资源加载错误: js/css/图片等
  if (target?.localName) {
    const errInfo = {
      type: 'source',
      name: target.localName,
      pathname: getCurrentRoute(),
      time: getTimestamp(),
      fileName: target.src || target.href,
    }
    return reportData(errInfo)
  }
}

function reportData(data) {
  if (_support.isEE) {
    _support.ipc.send(ipcApiRoute.errorLog, data)
  }
}

function install(Vue, options) {
  Vue.config.errorHandler = function (err, vm, info) {
    if (!(err instanceof Error) && err === 'cancel') {
      console.log(info)
      return
    }
    console.error(err)
    if (err.code !== 'ERR_CANCELED') {
      handleError(err)
    }
  }
  init(options)
}

export default {
  install,
}
